import { LinearProgress } from '@mui/material';

const Loading = () => {
  return (
    <LinearProgress color="secondary" />
  )
}

export default Loading;